import { FormControl, MenuItem, Select, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CreateMealAction } from '../../../../../store/create-meal-slice';

const ProvidedByComponent = () => {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);
  const mealProvider = useSelector((state) => state.createMeal.mealProvider);
  const availableMealProviders = useMemo(
    () =>
      [...new Set([...(user?.canteen?.mealProviders ?? []), mealProvider].filter(Boolean))],
    [mealProvider, user?.canteen?.mealProviders]
  );

  useEffect(() => {
    if (!mealProvider && availableMealProviders.length > 0) {
      dispatch(CreateMealAction.updateMealProvider(availableMealProviders[0]));
    }
  }, [availableMealProviders, dispatch, mealProvider]);

  const handleMealProviderChange = (event) => {
    dispatch(CreateMealAction.updateMealProvider(event.target.value));
  };

  return (
    <Grid2 container columnSpacing={1}>
      <Grid2 xs={2}>
        <Typography variant='s16_w600' component='span'>
          Provided By:*
        </Typography>
      </Grid2>
      <Grid2 xs={2} direction='row' gap={3} alignItems='center' display='flex'>
        <FormControl fullWidth>
          <Select
            value={mealProvider ?? ''}
            onChange={handleMealProviderChange}
          >
            {availableMealProviders.map((provider) => (
              <MenuItem value={provider} key={provider}>
                {provider}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid2>
    </Grid2>
  );
};

export default ProvidedByComponent;
